// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"532":"db6982da228420a76170","691":"3e8c11218c047db9ef83"}[chunkId] + ".js";
};